import React, { useEffect, useState } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api/api";
import parse from "html-react-parser";
import { useProfileStore } from "../../store/useUserStore";
import { useTranslation } from "react-i18next";
import { formatDate, formatDateDDMMYYYY, isImageFile, isPDFFile } from "../../helpers/helper";

type Props = {};

const EventDetail = (props: Props) => {
  const navigate = useNavigate();
  const [eventDetail, setEventDetail] = useState<any>({});
  let { eventId } = useParams();
  const { setLoading } = useProfileStore((state) => state);
  const { t } = useTranslation();

  useEffect(() => {
    if (eventId) {
      setLoading(true);
      api
        .get(`${process.env.REACT_APP_API_BASE_URL}/event/${eventId}`)
        .then((res) => {
          setLoading(false);
          setEventDetail(res.data.data);
        })
        .catch((err) => {
          setLoading(false);
          console.log("err cart", err);
        });
    }
  }, []);

  return (
    <div className="pb-28">
      <div className="mb-2 grid grid-cols-4 px-2">
        <div>
          <IoIosArrowBack
            className="rounded-full bg-theme p-1 cursor-pointer"
            size={28}
            color="#fff"
            onClick={() => navigate("/schedule")}
          />
        </div>
        <div className="text-center col-span-2 text-lg font-semibold">
          {t("schedule.eventDetail")}
        </div>
        <div></div>
      </div>

      <div className="pb-2 py-2 mx-2">
        <div className="grid grid-cols-12 gap-2 p-2.5 items-center ">
          <div className="col-span-1">
            <img
              src={
                eventDetail?.sender?.profile_pic || "/assets/img/koku-logo.png"
              }
              alt=""
              className="w-12 h-12 rounded-3xl drop-shadow"
            />
          </div>
          <div className=" col-span-9">
            <div className="text-lg font-semibold">
              {eventDetail?.sender?.name || "-"}
            </div>
            <div className="text-md font-light">
              {eventDetail.created_date
                ? formatDate(eventDetail.created_date)
                : "-"}
            </div>
          </div>
        </div>

        <div className="px-3 mt-6 text-xl font-semibold">
          {eventDetail.title}
        </div>

        <div className="px-3 mt-3 text-xl">
          {t("attendance.date")}: {formatDateDDMMYYYY(eventDetail.start_date)}{" "}
          to {formatDateDDMMYYYY(eventDetail.end_date)}
        </div>

        <div className="px-3 text-xl font-semibold">
          {eventDetail.location_type === "physical"
            ? t("schedule.physical")
            : t("schedule.online")}
          : {eventDetail.location_details}
        </div>

        <div className="px-3 mt-3 text-lg">
          {eventDetail.descriptions &&
            parse(eventDetail.descriptions?.replace(/\n/g, "<br />") || "")}
        </div>

        <div className="px-3 mt-3 text-lg">
          {(eventDetail.attachments && eventDetail.attachments.length) > 0 && (
            <div className="space-y-3">
              {eventDetail.attachments.map((attachment: any, index: number) => {
                if (isImageFile(attachment)) {
                  return (
                    <img
                      key={index}
                      src={attachment}
                      alt={`Attachment ${index}`}
                      className="image-class"
                    />
                  );
                } else if (isPDFFile(attachment)) {
                  return (
                    <a
                      key={index}
                      href={attachment}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center gap-2 p-3 bg-gray-100 rounded-lg hover:bg-gray-200"
                    >
                      <svg
                        className="w-6 h-6 text-red-600"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M4 18h12V6h-4V2H4v16zm8-14v4h4l-4-4z" />
                      </svg>
                      <span className="text-base">
                        PDF Document {index + 1}
                      </span>
                    </a>
                  );
                }
                return null;
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventDetail;
